export default __webpack_public_path__ + "static/media/filter.19ff181d.svg";